import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import {
  DioboxEvent, Form, FormStatus, FormType, ModalName,
} from "sharedTypes"
import { formStatusAndColor } from "utilities/forms"
import Icon from "components/elements/Icon"
import TextLink from "components/elements/Link"
import useModal from "services/useModal"
import Submissions from "./Submissions/Submissions"
import Link from "./Link"
import Visibility from "./Visibility"
import StatusRow from "./StatusRow"
import Status from "./Status"

type Props = {
  form: Form
  event: DioboxEvent
}

const StatusBox = ({ form, event }: Props) => {
  const {
    quantity,
    submissionLineItemsCount,
    submissionsEndAt,
    private: isPrivate,
    type,
    externalId,
  } = form
  const { id: eventId } = event
  const showModal = useModal()

  const { status, color } = formStatusAndColor(form, event)

  const generateCountsTitle = () => {
    switch (type) {
      case FormType.Registration:
        return "Registrations"
      case FormType.Ticket:
        return "Ticket Orders"
      case FormType.RSVP:
        return "RSVPs"
      case FormType.Waitlist:
      case FormType.Survey:
        return "Submissions"
      default:
        return ""
    }
  }

  return (
    <Box
      borderWidth={1}
      borderRadius="md"
      w="100%"
      px={6}
      pb={6}
      backgroundColor="white"
    >
      <StatusRow title="Status">
        <Status
          submissionsEndAt={submissionsEndAt}
          status={status}
          formType={type}
          color={color}
          event={event}
          eventFull={form.spotsLeft === 0}
        />
      </StatusRow>
      {status !== FormStatus.GatewayNotConnected && (
        <StatusRow title="Visibility">
          <Visibility isPrivate={isPrivate} status={status} type={type} />
        </StatusRow>
      )}
      <StatusRow title="Direct Link">
        <Link type={type} url={form.url} />
      </StatusRow>
      <StatusRow title={generateCountsTitle()}>
        <Submissions
          quantity={quantity}
          submissionLineItemsCount={submissionLineItemsCount}
          type={type}
          eventId={eventId}
          formId={externalId}
        />
      </StatusRow>
      {form.spotsLeft === 0 && (
        <Flex
          align="center"
          gap={2}
          mt={4}
          px={3.5}
          py={2.5}
          bg="orange.50"
          borderWidth={1}
          borderColor="orange.100"
          borderRadius="md"
          fontSize="sm"
        >
          <Icon icon="alert" color="orange.600" flexShrink={0} />
          <Text>
            Event capacity reached ({event.counts.confirmedGuests.toLocaleString()} confirmed).{" "}
            {type === FormType.RSVP
              ? "Guests can only decline until spots open up."
              : "This form is closed until spots open up."}{" "}
            <TextLink
              onClick={() => showModal(ModalName.EventCapacity, {
                languageTemplateId: form.languageTemplateId,
              })}
            >
              Edit Capacity
            </TextLink>
          </Text>
        </Flex>
      )}
    </Box>
  )
}

export default StatusBox
